module.exports = __webpack_public_path__ + "ae672978adabda8c73f961cfed678f24.png";